import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typewriter from "typewriter-effect";
import { introdata, meta } from "../../content_option";
import { Link } from "react-router-dom";

export const Home = () => {
  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <title> {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="intro_sec d-block d-lg-flex align-items-center ">
          {/* <div
            className="h_bg-image order-1 order-lg-2 h-100"
            style={{ backgroundImage: `url(${introdata.your_img_url})`, marginTop: '4em' }}
          ></div> */}
          <div className="text order-2 order-lg-1 h-100 d-lg-flex justify-content-center">
            <div className="align-self-center ">
              <div className="intro mx-auto">
                <h2 className="intro-data-class">{introdata.title}</h2>
                <h1 className="fluidz-48 mb-1x" style={{ marginTop: '1em' }}>
                  <Typewriter
                    options={{
                      strings: [
                        introdata.animated.first,
                        introdata.animated.second,
                        introdata.animated.third,
                      ],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 5,
                    }}
                  />
                </h1>
                <p className="mb-1x" style={{ fontFamily: 'Inter, sans-serif', marginTop: '7em' }}>
  Saphena's Luxury Enterprise is a highly esteemed Interior Design Consultancy and Project Management Agency, with a specialization in interior products procurement and supply. <br/><br/>
  Our company provides comprehensive interior design and decor services to corporate, residential, and retail clients. With a team of skilled, imaginative, and dedicated professionals, we deliver tailored design solutions that are truly unique. <br/><br/>
  Regardless of the project's scale, we approach each client's requirements on an individual basis, ensuring personalized attention. Moreover, we pride ourselves on delivering cost-effective interior design solutions without compromising on quality.
</p>

                <div className="intro_btn-action pb-5">
                  <Link to="/portfolio" className="text_2">
                    <div id="button_p" className="ac_btn btn " style={{ fontFamily: 'Inter, sans-serif', marginTop: '4em' }}>
                      Our Services
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                  <Link to="/contact">
                    <div id="button_h" className="ac_btn btn" style={{ fontFamily: 'Inter, sans-serif', marginTop: '4em' }}>
                      Contact Us
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};